import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'
import {
  IPricePerProduct,
  PriceDTO,
  PriceError,
  PricePerProduct
} from 'components/ordering/async-price/api/price-dto.js'

type GetPricesPayload = {
  productIds: string[]
}

export class GetPrices {
  path: string

  constructor({ productIds }: GetPricesPayload) {
    const queries = productIds.map((productId) => ['id', productId])
    const searchParams = new URLSearchParams(queries)
    this.path = `api/v1/product/v2/price/list/?${searchParams}`
  }

  parseResponse = parseAsyncPriceResponse

  parseError = parseAsyncPriceError
}

const validatePriceResponse = createValidate<IPricePerProduct>()
const parseAsyncPriceResponse = (data: unknown): PricePerProduct => {
  validateGuard(validatePriceResponse, data, 'price')

  const entries = Object.entries(data)
  const mappedEntries = entries.map(([id, dto]): [string, PriceDTO] => [id, new PriceDTO(dto)])

  return Object.fromEntries(mappedEntries)
}

const parseAsyncPriceError = (status: number, json: unknown) => {
  return new PriceError(status, json)
}
